import methods from '../methods'

export default {
    user: null,
    auth: null,
    status: null,
    carrinho: [],
    menu: [
        {
            label: 'PCdoB Digital',
            route: null,
            url: null,
            funcao: () => {
              methods.redirectToRV(process.env.VUE_APP_ENDPOINT_URL)
            },
            params: {},
            viewFooter: false,
            viewHeader: true,
        },
        {
            label: 'Contribua',
            route: null,
            url: process.env.VUE_APP_ENDPOINT_URL + 'contribuicao',
            funcao: null,
            params: {},
            viewFooter: false,
            viewHeader: true,
        },
    ],
}



// WEBPACK FOOTER //
// ./src/vuex/state.js